import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5d3141b6&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=5d3141b6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3141b6",
  null
  
)

export default component.exports